<!-- assessment-share-popup.component.html -->

<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="false"
  styleClass="assign-modal-container"
  (onHide)="close()"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
>
  <ng-template pTemplate="header">
      <h2 class="modal-title">{{config?.header}}</h2>
      <button class="close-button" (click)="close()">
        <i class="pi pi-times"></i>
      </button>
  </ng-template>

  <div class="modal-body">
    <form [formGroup]="shareForm" autocomplete="off">
      <!-- Container for Global RA and Email ID fields -->
      <div class="form-row">
        <!-- Global RA field -->
        <div class="form-group flex-grow-1">
          <label for="globalRa">Global RA <span class="required">*</span></label>
          <p-dropdown
            id="globalRa"
            [options]="filteredGlobalRaUsers"
            optionLabel="name"
            [filter]="true"
            formControlName="globalRa"
            placeholder="Select Global RA"
            (onChange)="onGlobalRaChange($event)"
            (onFilter)="debouncedSearch($event)"
            [showClear]="true"
          ></p-dropdown>
          <small *ngIf="filteredGlobalRaUsers.length === 0" class="text-muted">
            No users available to share with (all users are already shared with this assessment)
          </small>
        </div>
        <!-- Email ID field -->
        <div class="form-group flex-grow-1">
          <label for="emailId">Email ID <span class="required">*</span></label>
          <input
            id="emailId"
            type="email"
            pInputText
            placeholder="Enter Email"
            formControlName="emailId"
            [readonly]="true"
          />
        </div>
      </div>

      <!-- Remarks field -->
      <div class="form-group">
        <label for="remark" class="remark-label">Remark</label>
        <textarea
          id="remark"
          pInputTextarea
          rows="3"
          placeholder="Please enter the remarks"
          formControlName="remark"
        ></textarea>
      </div>
    </form>
  </div>

  <ng-template pTemplate="footer">
    <div class="footer-buttons">
      <button
        pButton
        type="button"
        label="Cancel"
        class="p-button-secondary"
        (click)="close()"
      ></button>
      <button
        pButton
        type="button"
        label="Share"
        class="p-button-warning"
        (click)="onSubmit()"
        [disabled]="shareForm.invalid || filteredGlobalRaUsers.length === 0"
      ></button>
    </div>
  </ng-template>
</p-dialog>